<div class="notification-container display-flex-container">
  <a
    id="headerNotification"
    class="notification-icon-container"
    href="javascript:void(0);"
    aria-label="Notification"
    rdxAnalytics="toggle notifications dropdown"
    (click)="toggleMenu()"
    i18n-aria-label
  >
    @if ($newNotifications().length) {
      <div class="badge">{{ $newNotifications().length }}</div>
    }
    <svg-icon src="/assets/icons/notification-outline.svg" />
  </a>

  @if (showingNotificationPanel) {
    <div class="notification-content helper-box-shadow">
      <div class="notification-header">
        <strong class="font-medium" i18n>Notifications</strong>
      </div>
      <div class="notification-message-container">
        @for (notification of $notifications(); track notification.id) {
          <div class="notification-message" [class.notification-read]="notification.notificationStatus === 'Read'">
            <a
              id="notificationMessage"
              href="javascript:void(0);"
              rdxAnalytics="click notification"
              [rdxAnalyticsData]="notification.notificationType"
              (click)="showDetails(notification)"
              >{{ notification.body }}</a
            >
            <a
              id="closeNotification"
              href="javascript:void(0);"
              aria-label="Close"
              rdxAnalytics="clear notification"
              (click)="markNotificationDismissed(notification)"
              i18n-aria-label
            >
              <svg-icon class="close-icon" src="/assets/icons/close.svg" alt="close" i18n-alt />
            </a>

            <p class="font-small">{{ notification.createDate | string | dateTime }}</p>
          </div>
        }
        @if (!$notifications().length) {
          <div class="notification-empty">
            <p i18n>You have no notifications</p>
          </div>
        }
      </div>
      <div class="notification-footer display-flex-container">
        <div class="flex-1">
          <a
            id="clearAllNotifications"
            class="footer-link"
            href="javascript:void(0);"
            rdxAnalytics="clear all notifications"
            [class.disabled]="!$notifications().length"
            (click)="markAllNotificationsDismissed()"
            i18n
            >Clear All</a
          >
        </div>

        <!--                <div class="flex-1 helper-align-right" *ngIf="notificationPreferencesLink$ | async as notificationPreferencesLink">-->
        <!--                    <a id="preferences" [routerLink]="notificationPreferencesLink" href="javascript:void(0);"-->
        <!--                       rdxAnalytics="click notifications preferences" class="footer-link" i18n>Preferences</a>-->
        <!--                </div>-->

        @if (notificationPreferencesLink$ | async; as notificationPreferencesLink) {
          <div class="flex-1 helper-align-right">
            <a
              id="preferences"
              class="footer-link"
              href="javascript:void(0);"
              rdxAnalytics="click notifications preferences"
              [routerLink]="notificationPreferencesLink"
              i18n
              >Preferences</a
            >
          </div>
        }
      </div>
    </div>
  }
</div>
